import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { DeviationDuperbrowseContext } from '../../Duperbrowse';
import GalleryGrid from './_partials/GalleryGrid';
import GalleryTorpedo from './_partials/GalleryTorpedo';
import MonoView from '../MonoView';
const GalleryView = (props)=>{
    var _deviations_, _props_linkOverrides;
    const { deviations, layout } = props;
    const isSingle = deviations.length === 1;
    var _props_linkOverrides_deviations__deviationId;
    return /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: deviations.reduce((prev, current)=>`${prev}-${current.deviationId}`, ''),
        deviations: deviations
    }, isSingle && deviations[0] && /*#__PURE__*/ React.createElement(MonoView, _object_spread_props(_object_spread({}, props), {
        deviation: deviations[0],
        link: (_props_linkOverrides_deviations__deviationId = (_props_linkOverrides = props.linkOverrides) === null || _props_linkOverrides === void 0 ? void 0 : _props_linkOverrides[(_deviations_ = deviations[0]) === null || _deviations_ === void 0 ? void 0 : _deviations_.deviationId]) !== null && _props_linkOverrides_deviations__deviationId !== void 0 ? _props_linkOverrides_deviations__deviationId : undefined
    })), !isSingle && layout === 'grid' && /*#__PURE__*/ React.createElement(GalleryGrid, props), !isSingle && layout === 'torpedo' && /*#__PURE__*/ React.createElement(GalleryTorpedo, props));
};
GalleryView.displayName = 'GalleryView';
export default GalleryView;

//# sourceMappingURL=GalleryView.js.map